import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { getScoreColorClassName } from '../../helpers';

import {
    PENTAGRAM_MAX_NORMAL_SCORE,
    PENTAGRAM_MIN_NORMAL_SCORE,
    PENTAGRAM_MIN_VALUE,
} from './constants';
import type { IPentagramFilledPolygon } from './models';
import { createPentagramPath, getScoreValues } from './helpers';
import styles from './styles.css';

export const FilledPolygon: FC<IPentagramFilledPolygon> = ({
    angle,
    radius,
    scores,
    totalScore,
}) => {
    const scoreClassName = getScoreColorClassName(
        totalScore,
        PENTAGRAM_MIN_NORMAL_SCORE,
        PENTAGRAM_MAX_NORMAL_SCORE
    );

    return (
        <path
            className={cn(styles.filledPolygon, styles[scoreClassName])}
            d={createPentagramPath(radius, angle, getScoreValues(scores), PENTAGRAM_MIN_VALUE)}
        />
    );
};
